import React from 'react';
// data
import Data from '../../../../model/Data';
import { links } from '../../data.json';
// styles
import './History.css'

interface Props {
  className?: string;
}

class History extends React.Component<Props> {

  render(): JSX.Element {
    const currentYear = new Date().getFullYear()

    return (
      <div className="about-history">
        <div className="container">
          <ul className="about-history__list events">
            <li className="events__item">
              <div className="events__date">2012</div>
              <div className="events__description">
                <a href={links.start2021}> все началось </a>
                с&nbsp;анимированных задачек по&nbsp;математике
              </div>
            </li>
            <li className="events__item">
              <div className="events__date">{currentYear}</div>
              <div className="events__description">
                мы — крупнейшая по&nbsp;аудитории образовательная онлайн&#8209;платформа для&nbsp;школьников в&nbsp;России
              </div>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default History;
